import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-xhr-backend';

//translations
import translationHR from './hr.json';

// the translations
const resources = {
  hr: {
    translation: translationHR,
  },
};

const loadEnglish = () => import(/* webpackChunkName: "locale-en" */ './en.json');

const languageLoaders = {
  en: loadEnglish,
  fr: loadEnglish,
  de: () => import(/* webpackChunkName: "locale-de" */ './de.json'),
  it: loadEnglish,
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    fallbackLng: 'hr',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    bindStore: false,
    //saveMissing: true,
    parseMissingKeyHandler: key => {
      return `No translation found for "${key}"`;
    },
  });

export const loadLanguage = async language => {
  if (languageLoaders[language] && !i18n.hasResourceBundle(language, 'translation')) {
    const { default: translation } = await languageLoaders[language]();

    i18n.addResourceBundle(language, 'translation', translation);
  }
};

export default i18n;
